import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateLeadService } from './create-lead.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MatStepper } from '@angular/material/stepper';
import { SharedService } from '../../shared/shared.service';
import moment from 'moment';
// import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// export function followupTimeValidator(): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     const selectedTime = control.value;

//     if (!selectedTime) {
//       return null;
//     }

//     const now = new Date();

//     // Compare only hours and minutes
//     const selectedMinutes =
//       selectedTime.getHours() * 60 + selectedTime.getMinutes();

//     const currentMinutes =
//       now.getHours() * 60 + now.getMinutes();

//     if (selectedMinutes > currentMinutes) {
//       console.log('future time will not be allowed')
//       return { futureTime: true };
//     }

//     return null;
//   };
// }

@Component({
  selector: 'app-create-lead',
  templateUrl: './create-lead.component.html',
  styleUrls: ['./create-lead.component.scss']
})
export class CreateLeadComponent implements OnInit {
  @ViewChild(MatStepper) stepper!: MatStepper;
  firstFormGroup!: FormGroup;
  secondFormGroup!: FormGroup;
  thirdFormGroup!: FormGroup;
  isLinear = true;
  firstFormSubmitted = false;
  secondFormSubmitted = false;
  thirdFormSubmitted = false;
  masters: any = [];
  sources: any = [];
  subSources: any = [];
  baseLeadSource: any = [];
  customerTitle:any = [];
  salesmanagers: any = [];
  categories: any = [];
  products: any = [];
  filteredProducts: any = []; // Newly added array to hold filtered products
  filteredSalesManagers: any = [];
  submitted = false;
  isLoading: Subject<boolean> = new Subject<boolean>();
  selectedProductId: any;
  selectedOption: any;
  isSalesManagerSelected: boolean = false;
  ageGroupList: any = [];
  genderList: any = [];
  customerInterest:any = []
  financeSource:any = []
  serviceAdvisors: any = [];
  filteredServiceAdvisors: any[] = [];
  userServiceAdvisors: any[] = [];
  hasUserAdvisorCodes: boolean = false;
  isShowServiceAdvisor: boolean = false;
  filteredVariants: any[] = [];
  filteredColors: any[] = [];
  productVariant: any = [];
  productColors: any = [];
  isOtpSent = false;
  otp: string = '';
  otpVerified: boolean = false;
  countdownTime: number = 180; // 3 minutes in seconds
  timer: any;
  otpSentMessage: string = '';
  otpExp: boolean = false;
  referenceType:any = [];
  professionList:any = [];
  customerType:any = [];
  actionList:any = [];
  followupList:any = [];
  daysToPruchaseList:any = [{id:'0-7', value: '0-7 Days'}, {id:'8-20', value: '8-20 Days'}, {id:'>21', value: '>21 Days'}];
  minDate: any =new Date();
  corporateList:any = [];
  isShowOtp:boolean = false;
  constructor(private toastr: ToastrService, private _formBuilder: FormBuilder, private createleadService: CreateLeadService, private sharedService: SharedService) { }

  ngOnInit() {
    const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');
    if (masters) {
      this.masters = masters;
      this.genderList = this.masters.gender || [];
      this.ageGroupList = this.masters.ageGroup || [];
      this.sources = this.masters.leadSource || [];
      this.baseLeadSource = this.masters.baseLeadSource || [];
      this.customerTitle = this.masters.customerTitle || [];
      this.subSources = this.masters.leadSubSource || [];
      this.salesmanagers = this.masters.salesManagers || [];
      this.categories = this.masters.productCategories || [];
      this.productVariant = this.masters.productVariant || [];
      this.productColors = this.masters.productColor || [];
      this.professionList = this.masters.occupation || [];
      this.customerType = this.masters.customerTypes || [];
      this.referenceType = this.masters.referenceTypes || [];
      this.actionList = this.masters.modeOfContact || [];
      this.followupList = this.masters.salesfollowUpReason || [];
      this.products = this.masters.productModel || [];
      this.corporateList = this.masters.corporate || [];
      console.log(this.products);
      
      this.customerInterest = this.masters.customerInterests || [];
      this.financeSource = this.masters.finance || [];
      this.serviceAdvisors = this.masters.serviceAdvisor || [];

    }

    // Only advisors of the logged-in user's dealer and location are selectable
    const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
    const outlet = loginResponse?.data?.user?.outlet;
    const dealerMapCode = outlet?.outlet_map_code;
    const locCode = outlet?.location_code;
    this.hasUserAdvisorCodes = !!dealerMapCode && !!locCode;
    this.userServiceAdvisors = this.hasUserAdvisorCodes
      ? this.serviceAdvisors.filter((advisor: any) =>
          String(advisor.dealer_map_code) === String(dealerMapCode) &&
          String(advisor.loc_code) === String(locCode))
      : [];

    this.firstFormGroup = this._formBuilder.group({
      customer_interest: ['', Validators.required],
      first_name: ['', Validators.required],
      middle_name: [''],
      last_name: [''],
      email: [''],
      mobile: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      gender: ['', Validators.required],
      title: ['', Validators.required],
      source: ['', Validators.required],
      service_advisor: [''],
      sub_source: [''],
      otp: [''],
    });

    this.firstFormGroup.get('mobile')?.valueChanges.subscribe(() => {
      this.firstFormGroup.patchValue({ otp: '' });
      this.isOtpSent = false;
      this.otpVerified = false;
  });

    this.secondFormGroup = this._formBuilder.group({
      base_lead_source: [''],
    
      reference_type: ['', Validators.required],
      reference_by: ['', Validators.required],
      sales_manager: ['', Validators.required],
      product_model: ['', Validators.required],
      product_category: ['', Validators.required],
      product_variant: ['', Validators.required],
      product_color: ['', Validators.required],
      finance: ['',Validators.required],
      profession: ['',Validators.required],
      customer_type: ['',Validators.required],
      // company_name: ['',Validators.required],
      corporate: [''],
      age_group: ['',Validators.required],
      days_to_purchase: ['',Validators.required],
      exchange: ['',Validators.required],
      quotation:['',Validators.required],
      remarks: [''],
    });
    // const d = new Date();
    // const today =
    //   String(d.getDate()).padStart(2, '0') + '/' +
    //   String(d.getMonth() + 1).padStart(2, '0') + '/' +
    //   d.getFullYear();

    // this.thirdFormGroup = this._formBuilder.group({
    //   date: [today, Validators.required],
    //   // time: ['', Validators.required,followupTimeValidator()],
    //   time: ['', [Validators.required, followupTimeValidator()]],
    //   // time: ['', Validators.required],
    //   action: ['', Validators.required],
    //   followup: ['', Validators.required]
    // });
    

    this.thirdFormGroup = this._formBuilder.group({
      date:['',Validators.required],
      time:['',Validators.required],
      action:['',Validators.required],
      followup:['',Validators.required]
    })



  }

  sendOtp() {
    const mobileNumber = this.firstFormGroup.get('mobile')?.value;
    const firstName = this.firstFormGroup.get('first_name')?.value;
    const middleName = this.firstFormGroup.get('middle_name')?.value;
    const lastName = this.firstFormGroup.get('last_name')?.value;
  
    if (mobileNumber) {
      // Call your service to send OTP
      this.createleadService.sendOtp({ mobile: mobileNumber, first_name: firstName, middle_name: middleName, last_name: lastName }).subscribe(
        response => {
          // Handle response (e.g., show success message)
          this.isOtpSent = true;
          this.otpExp = false; // Set OTP as not expired after sending OTP
          this.startCountdown();
        },
        error => {
          // Handle error
          this.toastr.error('Failed to send OTP');
        }
      );
    } else {
      this.toastr.error('Please enter a valid mobile number');
    }
  }
private startCountdown() {
  this.countdownTime = 180;
  this.otpSentMessage = 'OTP has been sent to your Mobile Number. Please enter OTP.';
  console.log(this.otpSentMessage);
  

  this.timer = setInterval(() => {
    if (this.countdownTime > 0) {
      this.countdownTime--;
    } else {
      clearInterval(this.timer);
      this.otpSentMessage = 'OTP expired!';
      this.otpExp = true;
      console.log(this.otpExp, 'this.otpExp');
      
    }
  }, 1000);
}

getFormattedTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

verifyOtp() {
  if (this.firstFormGroup.invalid) {
    return; // If the form is invalid, do nothing
  }
  this.createleadService.verifyOtp({
    mobile: this.firstFormGroup.get('mobile')?.value,
    otp: this.firstFormGroup.get('otp')?.value
  }).subscribe(
    response => {
      console.log('OTP Verification Response:', response);

      // Check the response structure and contents
      if (response.body.responseCode === 200) {
        this.toastr.success('OTP verified successfully');
        this.otpVerified = true; // Mark OTP as verified
        this.stepper.selectedIndex = 1; // Move to the next step
        this.firstFormSubmitted = false; // Reset the flag after proceeding
      } else {
        this.toastr.error('Invalid OTP');
      }
    },
    error => {
      console.error('Verification Error:', error);
      this.toastr.error('Verification failed');
      this.firstFormSubmitted = false; // Reset the flag on error
    }
  );
}


  get f() {
    return {
      ...this.firstFormGroup.controls,
      ...this.secondFormGroup.controls,
      ...this.thirdFormGroup.controls
    };
  }

  Space(event: any) {
    if (event.target.selectionStart === 0 && event.code === "Space") {
      event.preventDefault();
    }
  }

  onModelChange(event: any) {
    const target = event.target as HTMLSelectElement;
    const selectedOption = target.selectedOptions[0];
    this.selectedProductId = parseInt(selectedOption.id);
    const selectedProductId = parseInt(event.target.value);
    this.filteredVariants = this.productVariant.filter((variant:any) => variant.model_id === selectedProductId);
    this.filteredColors = [];
    // const colorIds = this.filteredVariants[0].color_id[0].split(',').map((id:any) => parseInt(id)); // Split and convert to numbers
      // Filter product colors based on selected variant's color IDs
  //  this.filteredColors = this.productColors.filter((color: any) => colorIds.includes(color.id));
    // this.secondFormGroup.patchValue({
    //   product_variant: this.filteredVariants[0].id+":"+this.filteredVariants[0].variant,
    //   product_color: this.filteredColors[0].id+":"+this.filteredColors[0].color
    // });
    setTimeout(()=>{
      this.secondFormGroup.patchValue({
        product_variant:"",
        product_color:'',
      })
    },100)
   
  }

//   onVariantChange(event: any) {
//     const target = event.target as HTMLSelectElement;
//     const selectedOption = target.selectedOptions[0];
//     const selectedVariant = selectedOption.value.split(':')[0]; // Get variant ID
//     this.selectedProductId = parseInt(selectedVariant);

//     // Find the selected variant object
//     const variantObj = this.productVariant.find((variant: any) => variant.id === this.selectedProductId);

//     if (variantObj) {
//         // Extract color IDs from the selected variant
//         const colorIds = variantObj.color_id;

//         // Filter product colors based on selected variant's color IDs
//         this.filteredColors = this.productColors.filter((color: any) => colorIds.includes(color.id.toString()));
//     } else {
//         this.filteredColors = []; // Reset if no matching variant found
//     }

//     console.log(this.filteredColors, 'this.filteredColors');
// }

onVariantChange(event: any) {
  const target = event.target as HTMLSelectElement;
  const selectedOption = target.selectedOptions[0];
  const selectedVariant = selectedOption.value.split(':')[0]; // Get variant ID
  this.selectedProductId = parseInt(selectedVariant);

  // Find the selected variant object
  const variantObj = this.productVariant.find((variant: any) => variant.id == this.selectedProductId);
  if (variantObj) {
      // Extract color IDs from the selected variant (assuming it's an array of strings)
      const colorIds = variantObj.color_id; // Split and convert to numbers

      // Filter product colors based on selected variant's color IDs
      this.filteredColors = this.productColors.filter((color: any) => colorIds.includes(color.id));
      setTimeout(()=>{
        this.secondFormGroup.patchValue({
          product_color:'',
        })
      },100)
  } else {
      this.filteredColors = []; // Reset if no matching variant found
  }

  console.log(this.filteredColors, 'this.filteredColors');
}


  // submitFirstForm() {
  //   this.firstFormSubmitted = true;
  //   if (this.firstFormGroup.invalid) {
  //     return;
  //   }
  //   this.firstFormSubmitted = false; // Reset the flag
  // }
  submitFirstForm() {
    this.firstFormSubmitted = true; // Set the flag to true
    console.log("firstFormGroup: ", this.firstFormGroup.value)
    if (this.firstFormGroup.invalid) {
      return; // If the form is invalid, do nothing
    }
  
    // Check if OTP is sent
    if (this.isOtpSent) {
      // Validate OTP before proceeding
      this.verifyOtp();
    } else {
      // Proceed to the next step if OTP not required
      this.stepper.selectedIndex = 1; // Move to the next step
      this.firstFormSubmitted = false; // Reset the flag after proceeding
      this.isOtpSent = false;
    }
  }

  submitSecondForm() {
    console.log("secondFormGroup: ", this.secondFormGroup.value)
    this.secondFormSubmitted = true; // Set the flag to true
  
    if (this.secondFormGroup.invalid) {
      return; // If the form is invalid, do nothing
    }
 
  }
  

  resetSalesManager() {
    this.secondFormGroup.patchValue({
      sales_manager: ''
    });
    this.isSalesManagerSelected = false;
  }

  onSalesManagerSelected() {
    this.isSalesManagerSelected = !!this.secondFormGroup.value.sales_manager;
  }


  submitThirdForm() {
    this.thirdFormSubmitted = true;

    if (this.firstFormGroup.invalid || this.secondFormGroup.invalid ||this.thirdFormGroup.invalid) {
      return;
    }

    // Parse the sales_manager value to an integer
    const salesManagerValue = parseInt(this.secondFormGroup.value.sales_manager);
    let sourceId:any = this.firstFormGroup.value.source.split(":")[0]
    let filteredSources:any = this.sources.filter((source:any) => source.id == parseInt(sourceId));
    let filteredBaseSource:any = []
    if(filteredSources.length > 0){
      filteredBaseSource = this.baseLeadSource.filter((source:any) => source.id == parseInt(filteredSources[0].base_lead_source_id));
    }
    if(filteredSources.length > 0){
      this.secondFormGroup.patchValue({
        base_lead_source: filteredBaseSource[0].id +":"+ filteredBaseSource[0].base_lead_source
      })
    }

    let followupDate: any = moment(this.thirdFormGroup.get('date')?.value).format('YYYY-MM-DD');
    // let followupDate: any = moment(this.thirdFormGroup.get('date')?.value,'DD-MM-YYYY').format('YYYY-MM-DD');
    
    let followupTime = moment(this.thirdFormGroup.value.time, 'hh:mm A').format('HH:mm');

    let leadData:any = {
      ...this.firstFormGroup.value,
      ...this.secondFormGroup.value,
      sales_manager: salesManagerValue,
      // base_lead_source:"2:Offline",
      // lead_source:"3:Walk-in"
      base_lead_source:this.secondFormGroup.value.base_lead_source,
      lead_source: this.firstFormGroup.value.source,
      followup: this.thirdFormGroup.value.followup,
      action:this.thirdFormGroup.value.action,
      next_followup_date: followupDate + ' ' + followupTime
    };
    leadData['service_advisor'] = this.isShowServiceAdvisor ? (this.firstFormGroup.value.service_advisor || '') : '';
    leadData['lead_sub_source'] = this.firstFormGroup.value.sub_source ? this.firstFormGroup.value.sub_source :'',
    console.log("leadData: ", leadData)
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.createleadService.createLead(leadData).subscribe((response: any) => {
      let responseData = response.body;
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.success("Lead created successfully!")
           this.clearForm();
        this.firstFormSubmitted = false;
        this.secondFormSubmitted = false;
        this.thirdFormSubmitted = false;
        this.stepper.selectedIndex = 0;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(responseData.responseMessage)
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  capitalizeInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;

    if (inputValue.length === 0) return;

    const capitalizedValue = inputValue.charAt(0).toUpperCase() + inputValue.slice(1).toLowerCase();

    input.value = capitalizedValue;
    this.firstFormGroup.patchValue({ name: capitalizedValue });
  }

  clearForm() {
    this.firstFormGroup.patchValue({
      customer_interest: '',
      first_name: '',
      last_name: '',
      middle_name: '',
      email: '',
      mobile: '',
      gender: '',
      title: '',
      otp: '',
      source: '',
      service_advisor: '',
      sub_source: '',
    });
    this.isShowServiceAdvisor = false;
    this.filteredServiceAdvisors = [];

    this.secondFormGroup.patchValue({
      base_lead_source: '',
      reference_type: '',
      reference_by: '',
      sales_manager: '',
      product_model: '',
      product_category: '',
      product_variant: '',
      product_color: '',
      finance: '',
      profession: '',
      customer_type: '',
      company_name: '',
      age_group: '',
      days_to_purchase: '',
      exchange: '',
      quotation: '',
      remarks: ''
    });
    
    this.thirdFormGroup.patchValue({
      date: '',
      time: '',
      action: '',
      followup: ''
    });
    
  }


  allowAplhabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }

  allowNumbersOnly(event: any) {
    this.sharedService.allowNumbersOnly(event);
  }

  onCategoryChange(event: any) {
    const categoryId = event.target.value;
    console.log(categoryId);
    this.filteredColors = [];
    if (categoryId) {
      this.filteredProducts = this.products.filter((product: any) => product.category_id === parseInt(categoryId));
      this.filteredSalesManagers = this.salesmanagers.filter((catSales: any) => catSales.category_id === parseInt(categoryId));
      console.log(this.filteredProducts);
      console.log(this.filteredSalesManagers);
      
      
      this.secondFormGroup.patchValue({
        product_model: '',
        product_variant: '',
        product_color: '',
        sales_manager: ''
      });
    } else {
      this.filteredProducts = [];
      this.filteredSalesManagers = [];
    }
  }
  filteredSources: any[] = [];
  onBaseSourceChange(event: any) {
    const baseLeadSourceId = parseInt(event.target.value.split(':')[0]); // Get the selected base lead source ID

    // Filter the lead sources based on the selected base lead source
    this.filteredSources = this.sources.filter((source:any) => source.base_lead_source_id === baseLeadSourceId);

    // Reset the source and sub source fields
    this.secondFormGroup.patchValue({
      source: '',
      sub_source: ''
    });

    this.filteredSubSource = []; // Reset the filtered sub sources
  }

  filteredSubSource: any = []
  isShowReference:boolean = false;
  // onSourceChange(event: any) {
  //   const sourceId = event.target.value;
  //   this.isShowServiceAdvisor = this.isServiceAdvisorSource(sourceId);
  //   this.firstFormGroup.patchValue({ service_advisor: '' });
  //   if (sourceId) {
  //     if(parseInt(sourceId) == 9 || parseInt(sourceId) == 15){
  //       this.isShowOtp = true;
  //     }else{
  //       this.isShowOtp = false;
  //     }
  //     if(parseInt(sourceId) == 17){
  //       this.isShowReference = true;
  //       this.secondFormGroup.controls['reference_type'].enable()
  //       this.secondFormGroup.controls['reference_by'].enable()
  //     }else{
  //       this.isShowReference = false;
  //       this.secondFormGroup.controls['reference_type'].disable()
  //       this.secondFormGroup.controls['reference_by'].disable()
  //     }
  //     this.filteredSubSource = this.subSources.filter((element: any) => element.lead_source_id === parseInt(sourceId));
  //     this.firstFormGroup.patchValue({
  //       sub_source: ''
  //     });

  //   if (this.filteredSubSource.length > 0) {
  //     // Make sub_source mandatory
  //     this.firstFormGroup.get('sub_source')?.setValidators([Validators.required]);
  //   } else {
  //    // Remove mandatory validation if no subSources
  //     this.firstFormGroup.get('sub_source')?.clearValidators();
  //   }
  //     this.firstFormGroup.get('sub_source')?.updateValueAndValidity();
  //   } else {
  //     this.filteredSubSource = [];
  //   }
  // }
  onSourceChange(event: any) {
  const sourceValue = event.target.value;
  const sourceId = parseInt(sourceValue.split(':')[0], 10);

  this.isShowServiceAdvisor = this.isServiceAdvisorSource(sourceValue);

  // Reset Service Advisor when the Lead Source changes.
  this.firstFormGroup.patchValue({
    service_advisor: '',
    sub_source: ''
  });

  if (this.isShowServiceAdvisor) {
    this.filteredServiceAdvisors = this.userServiceAdvisors;
    if (!this.hasUserAdvisorCodes) {
      this.toastr.error('Dealer or location code not found for the logged-in user');
    }
    this.firstFormGroup.get('service_advisor')?.setValidators([
      Validators.required
    ]);
  } else {
    this.filteredServiceAdvisors = [];
    this.firstFormGroup.get('service_advisor')?.clearValidators();
  }

  this.firstFormGroup.get('service_advisor')?.updateValueAndValidity({
    emitEvent: false
  });

  if (sourceValue) {
    this.isShowOtp = sourceId === 9 || sourceId === 15;

    if (sourceId === 17) {
      this.isShowReference = true;
      this.secondFormGroup.controls['reference_type'].enable();
      this.secondFormGroup.controls['reference_by'].enable();
    } else {
      this.isShowReference = false;
      this.secondFormGroup.controls['reference_type'].disable();
      this.secondFormGroup.controls['reference_by'].disable();
    }

    this.filteredSubSource = this.subSources.filter(
      (element: any) => element.lead_source_id === sourceId
    );

    if (this.filteredSubSource.length > 0) {
      this.firstFormGroup.get('sub_source')?.setValidators([
        Validators.required
      ]);
    } else {
      this.firstFormGroup.get('sub_source')?.clearValidators();
    }

    this.firstFormGroup.get('sub_source')?.updateValueAndValidity({
      emitEvent: false
    });
  } else {
    this.filteredSubSource = [];
    this.firstFormGroup.get('sub_source')?.clearValidators();
    this.firstFormGroup.get('sub_source')?.updateValueAndValidity({
      emitEvent: false
    });
  }
}

  trackByEmpCode(_index: number, advisor: any) {
    return advisor.emp_code;
  }

  // Source value is "id:name"; Workshop Enquiry is identified by its name
  isServiceAdvisorSource(sourceValue: string): boolean {
    const name = (sourceValue || '').split(':').slice(1).join(':');
    return name.toLowerCase().replace(/[^a-z0-9]/g, '') === 'workshopenquiry';
  }

  previous(){
    this.otpExp = true;
    this.otpVerified = false;
    this.firstFormGroup.patchValue({
      otp: ''
    })
  }

  isShowCompanyName:boolean = false;
  onCustomerTypeChange(event:any){
    const customerTypeId =  parseInt(event.target.value.split(':')[0]);
    if(customerTypeId == 1){
      this.secondFormGroup.controls['corporate'].enable()
      this.isShowCompanyName = true;
    }else{
      this.isShowCompanyName = false;
      this.secondFormGroup.controls['corporate'].disable()
    }
  }
}
